import { PagedResponse } from "@/types/PagedResponse";
import { PageRequest } from "@/types/pagination";
import { Seguradora as SeguradoraDTO } from "@/types/SeguradoraDTO";
import { Sort } from "@/types/sort";
import { buildFilter } from "@/utils/filter.util";
import axios, { AxiosPromise } from "axios"; 

export const findSeguradoras = (searchParams?: string, pagination?: PageRequest, sort?: Sort): AxiosPromise<PagedResponse<SeguradoraDTO>> => 
    axios.get(`/api/seguradora`, {
        params: {
            search: searchParams,
            ...sort,
            ...pagination
        }
    });

export const autoCompleteAtivo = (search: string): AxiosPromise<PagedResponse<any>> =>
    findSeguradoras(search ? buildFilter(['nome'])(search) : '',{page: 0, size: 20},{sort: 'nome'});

export const getByCodigo = (codigo: string): AxiosPromise<SeguradoraDTO> => 
    axios.get(`/api/seguradora/${codigo}`);    

export const create = (seguradora: SeguradoraDTO): AxiosPromise<SeguradoraDTO> => 
    axios.post(`/api/seguradora`, seguradora); 

export const update = (seguradora: SeguradoraDTO, id: string): AxiosPromise<SeguradoraDTO> => 
    axios.put(`/api/seguradora/${id}`, seguradora); 

export const remove = (codigo: string): AxiosPromise<void> => 
    axios.delete(`/api/seguradora/${codigo}`);     